import React from 'react';
import { css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import productColor from 'components/styles';
import IconLabelButton from 'components/molecules/IconLabelButton';
import { useHistory } from 'react-router-dom';
import ContextMenu from 'components/molecules/ContextMenu';

const styles = {
  customStyle: css({
    marginRight: ' 15px',
    justifyContent: 'flex-end',
    zIndex:'revert',
    position: 'relative'
  },css`
  button:hover {
    background-color:transparent;
  }
  `),
  customButton: css({
    backgroundColor: 'transparent'
  })
}

const ButtonNavigation: React.FC<{
  downloadStaffCsv: () => void;
  downloadStaffSalaryCsv: () => void;
  downloadStaffManagerCsv: () => void;
  downloadStaffHolidayCsv:() => void;
}> = ({ downloadStaffCsv, downloadStaffManagerCsv, downloadStaffHolidayCsv }) => {
  const history = useHistory();
  const isAuthorizedFromPeople = process.env.REACT_APP_IS_AUTHORIZED_FROM_PEOPLE === "true"|| false;

  const contextMenuButtons = [
    {
      isRed: false,
      isSelectable: true,
      isHidden: false,
      label: 'スタッフ情報',
      stamptype: 0,
      onClick: () => {
        return downloadStaffCsv();
      },
    }, 
    {
      isRed: false,
      isSelectable: true,
      isHidden: false,
      label: 'マネージャー権限',
      stamptype: 0,
      onClick: () => {
        return downloadStaffManagerCsv();
      },
    },
    {
      isRed: false,
      isSelectable: true,
      isHidden: false,
      label: '介護・看護休暇情報',
      stamptype: 0,
      onClick: () => {
        return downloadStaffHolidayCsv();
      },
    },
  ];

  return (
    <FlexBox customStyle={styles.customStyle}>
      {isAuthorizedFromPeople?'':
        <FlexBoxItem marginLeft="10px">
          <IconLabelButton textColor={productColor.primary} onClick={() => { history.push('/staffs/add') }} iconType="addCircle" text="追加" />
        </FlexBoxItem>
      }
      <FlexBoxItem marginLeft="10px">
        <IconLabelButton textColor={productColor.primary} onClick={() => { history.push('/staffs/csv') }} iconType="addCircle" text="インポート" />
      </FlexBoxItem>
      <FlexBoxItem marginLeft="10px">
        {/* <IconLabelButton onClick={() => downloadStaffCsv()} iconType="download" text="CSVダウンロード" /> */}
        <ContextMenu
          text="CSVダウンロード"
          buttons={contextMenuButtons}
          position="bottom"
          customStyle={styles.customButton}
          isButtonText={true}
          hiddenDropIcon={true}
        />
      </FlexBoxItem>
    </FlexBox>
  )
}

export default ButtonNavigation;
